import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/LanguageContext";

const KEY = "nvl.cookies.acknowledged";

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = window.localStorage.getItem(KEY);
      if (!v) setVisible(true);
    } catch {}
  }, []);

  if (!visible) return null;

  const accept = () => {
    try {
      window.localStorage.setItem(KEY, new Date().toISOString());
    } catch {}
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t"
      style={{
        borderColor: "hsl(var(--nvl-border))",
        backgroundColor: "hsl(var(--nvl-bg) / 0.98)",
        backdropFilter: "blur(10px)",
      }}
      data-testid="cookie-banner"
    >
      <div className="nvl-container py-4 flex flex-col md:flex-row md:items-center gap-3">
        <p className="text-sm flex-1" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
          {t("app.legal.cookies.banner.message")}{" "}
          <Link to="/legal/cookies" className="underline" data-testid="cookie-banner-more">
            {t("app.legal.cookies.banner.moreInfo")}
          </Link>
        </p>
        <button
          onClick={accept}
          className="nvl-btn nvl-btn-primary text-sm"
          data-testid="cookie-banner-accept"
        >
          {t("app.legal.cookies.banner.accept")}
        </button>
      </div>
    </div>
  );
}
